import { render, staticRenderFns } from "./pass.vue?vue&type=template&id=20881a65&scoped=true&"
import script from "./pass.vue?vue&type=script&lang=js&"
export * from "./pass.vue?vue&type=script&lang=js&"
import style0 from "./pass.vue?vue&type=style&index=0&id=20881a65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20881a65",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20881a65')) {
      api.createRecord('20881a65', component.options)
    } else {
      api.reload('20881a65', component.options)
    }
    module.hot.accept("./pass.vue?vue&type=template&id=20881a65&scoped=true&", function () {
      api.rerender('20881a65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/finance/userWithdrawal/pass.vue"
export default component.exports